export const configSelector = (state) => state.config || {};
